import styled from "@emotion/styled";
export const Container = styled.div`
  padding: 0 10% 10%;
`;

export const Step = styled.div`
  display: flex;
  justify-content: right;
  align-items: center;
  margin-top: 54px;
`;
export const YellowText = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 30px;
  letter-spacing: -0.025em;
  text-transform: uppercase;
  color: #ffce26;
`;
export const Gap = styled.div`
  margin: 0.25%;
`;

export const SmallText = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 30px;
  letter-spacing: 0.04em;
  color: #575757;
`;
export const Title = styled.div`
  font-weight: 900;
  font-size: 30px;
  color: #575757;
`;

export const SubTitle = styled.div`
  font-weight: 900;
  font-size: 14px;
  color: #575757;
  margin-top: 33px;
`;

export const OuterCard = styled.div`
  margin: 0 -5px;
`;

export const Card = styled.div`
  float: left;
  width: 30%;
  padding: 30px;
  background: #ffffff;
  border: 1px solid #f4f4f4;
  box-sizing: border-box;
  box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  margin: 33px 10px;
`;

export const Upper = styled.div`
  height: 120px;
  display: block;
  overflow: auto;
  width: 100%;
`;

export const TopicTitle = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 35px;
  margin-bottom: 0;
  color: #575757;
`;
export const Description = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: #a6a6a6;
`;

export const Names = styled.div`
  display: inline-block;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: #a6a6a6;
`;

export const SmallNames = styled.div`
  display: inline-block;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: #a6a6a6;
`;

export const IdealBorder = styled.div`
  margin-top: 2%;
  display: grid;
  grid-template-columns: 10fr 1fr 1fr 1fr 1fr;
  place-content: end right;
`;

export const StartButton = styled.button`
  display: inline-block;
  width: 111px;
  height: 32px;
  background: #575757;
  border-radius: 8px;
  color: white;
  font-size: 10px;
  cursor: auto;
`;

export const ActivityButton = styled.button`
  display: inline-block;
  width: 111px;
  height: 32px;
  background: #ffce26;
  border-radius: 8px;
  font-size: 10px;
  color: black;
`;

export const IdealBorderImg = styled.img`
  display: inline-block;
  margin-top: 10px;
`;

export const IdealBorderNum = styled.div`
  display: inline-block;
  font-style: normal;
  font-weight: normal;
  font-size: 8px;
  line-height: 10px;
  color: #a6a6a6;
  margin-top: 10px;
`;

export const EditText = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  color: #a6a6a6;
`;
export const Action = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: right;
  margin-left: auto;
`;
export const ProgressBarContainer = styled.div`
  background-color: #f1f1f1;
  border-radius: 16px;
  width: 132px;
  height: 6px;
`;
export const ProgressBar = styled.div`
  width: ${({ progress }) => `${progress}%`};
  height: 6px;
  background-color: #ffce26;
  border-radius: 16px;
`;
export const ProgressContainer = styled.div`
  text-align: right;
`;
export const ActionContainer = styled.div`
  text-align: right;
  margin-left: 38px;
`;

export const ProgressText = styled.p`
  font-size: 12px;
  line-height: 16px;
  color: #575757;
`;
